import {createAsyncThunk} from "@reduxjs/toolkit";
import {handlerError} from "../../../store/handleError";
import {companyAPI} from "../api";
import {ICompany} from "../../../models/iCompanies";
import {setModalMessage} from "../../messages/model/slice";

export const fetchCheckCompanyById = createAsyncThunk(
    "companies/check_company_by_id",
    async (company_id: string, {rejectWithValue, dispatch}) => {
        try {
            return await companyAPI.checkById(company_id);
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

export const fetchUpdateCompany = createAsyncThunk(
    "companies/update",
    async (company: ICompany, {rejectWithValue, dispatch}) => {
        try {
            return await companyAPI.update(company);
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    });
